import { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import L from "leaflet";
import "leaflet.heat";
import { UserContext } from "../../context";

const MapaDeCalor = (props) => {
  const { data, height, minZoom = 11, maxZoom = 20, heatLayerRadius = 15, heatLayerMaxZoom = 5, defaultCenterLat = -38.951832, defaultCenterLng = -68.059431, defaultZoom = 15 } = props;

  const { actions: ua } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    const buildMap = () => {
      if (!data) {
        return;
      }

      let container = L.DomUtil.get("map");
      if (container != null) {
        container._leaflet_id = null;
      }

      let map = L.map("map", { attributionControl: false }).setView([defaultCenterLat, defaultCenterLng], defaultZoom);
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        minZoom: minZoom,
        maxZoom: maxZoom,
      }).addTo(map);
      L.heatLayer(data, {
        radius: heatLayerRadius,
        maxZoom: heatLayerMaxZoom,
      }).addTo(map);

      // return () => map.remove();
    };

    if (ua.hasRole("sudo")) {
      buildMap();
    } else {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return <div id='map' style={{ width: "100%", height: height, borderRadius: "0.375rem" }}></div>;
};

export default MapaDeCalor;
